import { render, staticRenderFns } from "./compare-card.vue?vue&type=template&id=42447aad&scoped=true&"
import script from "./compare-card.vue?vue&type=script&lang=ts&"
export * from "./compare-card.vue?vue&type=script&lang=ts&"
import style0 from "./compare-card.vue?vue&type=style&index=0&id=42447aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42447aad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCol,VRow,VSwitch})
